import { PERMISSIONS as P } from "../../constants/permissions";

// How the manufacturing Role Management screen lays out permissions: one
// section per area of the app, each permission with a plain-English label and
// a line on what it actually allows. Any MANUFACTURING_ / CUSTOMER_ permission
// not listed here still shows, under "Other", so a new one is never hidden.
export const MANUFACTURING_PERMISSION_SECTIONS = [
  {
    title: "General",
    description: "Module-wide access and actions that reach every worker.",
    permissions: [
      { value: P.MANUFACTURING_VIEW, label: "Manufacturing access", hint: "General access to the manufacturing module" },
      { value: P.MANUFACTURING_MANAGE, label: "Message workers", hint: "Request progress updates from all workers and notify a stage's assignee" },
    ],
  },
  {
    title: "Purchase Orders",
    description: "POs, their stages and day-to-day production reporting.",
    permissions: [
      { value: P.MANUFACTURING_PO_VIEW, label: "View POs", hint: "PO list, PO details, stage progress, comments and the PO report" },
      { value: P.MANUFACTURING_PO_CREATE, label: "Create POs", hint: "New POs, including uploading a PO document to read it in" },
      { value: P.MANUFACTURING_PO_UPDATE, label: "Edit POs", hint: "Change status, archive and unarchive" },
      { value: P.MANUFACTURING_STAGE_UPDATE, label: "Report stage progress", hint: "Mark parts OK, rejected or for rework, comment, and record shipments" },
    ],
  },
  {
    title: "Profit & Loss",
    description: "Selling prices, costs and the loss from rejects and rework. Hidden entirely without one of these.",
    permissions: [
      { value: P.MANUFACTURING_PNL_VIEW, label: "View P&L", hint: "The P&L on each PO and the P&L tab in Reports" },
      { value: P.MANUFACTURING_PNL_MANAGE, label: "Edit P&L", hint: "Enter and change prices, costs and reject / rework counts (includes viewing)" },
    ],
  },
  {
    title: "Workflows & Parts",
    description: "The production templates and part catalogue POs are built from.",
    permissions: [
      { value: P.MANUFACTURING_WORKFLOW_VIEW, label: "View workflow templates" },
      { value: P.MANUFACTURING_WORKFLOW_MANAGE, label: "Manage workflow templates", hint: "Create and edit templates" },
      { value: P.MANUFACTURING_PARTS_VIEW, label: "View Parts Master" },
      { value: P.MANUFACTURING_PARTS_MANAGE, label: "Manage Parts Master", hint: "Add and edit parts, codes and unit costs" },
    ],
  },
  {
    title: "Inventory",
    description: "Stock levels and movements.",
    permissions: [
      { value: P.MANUFACTURING_INVENTORY_VIEW, label: "View stock", hint: "Stock, stock movements and inventory reports" },
      { value: P.MANUFACTURING_INVENTORY_MANAGE, label: "Manage inventory", hint: "Log stock movements and change inventory settings" },
    ],
  },
  {
    title: "Assigned Tasks",
    description: "Recurring check-ins sent to workers over chat.",
    permissions: [
      { value: P.MANUFACTURING_ALLOTTED_TASK_VIEW, label: "View assigned tasks", hint: "See every task and everyone's responses" },
      { value: P.MANUFACTURING_ALLOTTED_TASK_MANAGE, label: "Manage assigned tasks", hint: "Create and edit tasks and pick assignees" },
    ],
  },
  {
    title: "Assets",
    description: "Machines, maintenance and breakdowns.",
    permissions: [
      { value: P.MANUFACTURING_ASSET_VIEW, label: "View assets", hint: "Machines, warranties, maintenance history, breakdowns and downtime" },
      { value: P.MANUFACTURING_ASSET_MANAGE, label: "Manage assets", hint: "Add and edit machines, warranties, checklists, PM schedules and asset settings" },
      { value: P.MANUFACTURING_ASSET_MAINTAIN, label: "Maintain assets", hint: "Log maintenance, complete PM checklists, acknowledge and resolve breakdowns" },
      { value: P.MANUFACTURING_ASSET_BREAKDOWN_REPORT, label: "Report breakdowns", hint: "In the app, or with /breakdown on chat" },
    ],
  },
  {
    title: "Customers",
    description: "Customer records and their view-only portal links.",
    permissions: [
      { value: P.CUSTOMER_VIEW, label: "View customers" },
      { value: P.CUSTOMER_CREATE, label: "Create customers" },
      { value: P.MANUFACTURING_PORTAL_MANAGE, label: "Manage customer links", hint: "Issue, revoke and inspect customer view-only links" },
    ],
  },
  {
    title: "Reports",
    description: "Production and inventory reporting.",
    permissions: [
      { value: P.MANUFACTURING_REPORTS_VIEW, label: "View reports", hint: "Daily, status and part-wise reports and exports" },
    ],
  },
];
